import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from '../../components/toast';
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";

// Fetch all therapists (list)
export const fetchTherapists = createAsyncThunk(
  "therapistManagement/fetchTherapists",
  async ({ search = "", status = "All", page = 1, limit = 10 } = {}, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const params = new URLSearchParams();
      if (search) params.append("search", search);
      if (status && status !== "All") params.append("status", status);
      params.append("page", page.toString());
      params.append("limit", limit.toString());

      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.getTherapists}?${params.toString()}`
      );
      if (response?.data?.status === true) {
        return response.data.data;
      }
      return rejectWithValue(response?.data?.message || "Failed to fetch therapists");
    } catch (error) {
      const msg = error?.response?.data?.message || error.message || "Failed to fetch therapists";
      return rejectWithValue(msg);
    }
  }
);

// Get therapist by ID (view details)
export const fetchTherapistById = createAsyncThunk(
  "therapistManagement/fetchTherapistById",
  async ({ id }, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.getTherapistById}/${id}`
      );
      if (response?.data?.status === true) {
        return response.data.data;
      }
      return rejectWithValue(response?.data?.message || "Therapist not found");
    } catch (error) {
      const msg = error?.response?.data?.message || error.message || "Failed to fetch therapist details";
      return rejectWithValue(msg);
    }
  }
);

// Create therapist
export const createTherapist = createAsyncThunk(
  "therapistManagement/createTherapist",
  async (payload, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const response = await axiosPrivate.post(
        `${process.env.REACT_APP_API_URL}${APP_PATH.createTherapist}`,
        payload
      );
      if (response?.data?.status === true) {
        toast.success("Therapist added successfully");
        return response.data.data;
      }
      toast.error(response?.data?.message || "Failed to create therapist");
      return rejectWithValue(response?.data?.message || "Failed to create therapist");
    } catch (error) {
      const msg = error?.response?.data?.message || error.message || "Failed to create therapist";
      toast.error(msg);
      return rejectWithValue(msg);
    }
  }
);

// Update therapist by ID
export const updateTherapist = createAsyncThunk(
  "therapistManagement/updateTherapist",
  async ({ id, ...payload }, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const response = await axiosPrivate.put(
        `${process.env.REACT_APP_API_URL}${APP_PATH.updateTherapistById}/${id}`,
        payload
      );
      if (response?.data?.status === true) {
        toast.success("Therapist updated successfully");
        return response.data.data;
      }
      toast.error(response?.data?.message || "Failed to update therapist");
      return rejectWithValue(response?.data?.message || "Failed to update therapist");
    } catch (error) {
      const msg = error?.response?.data?.message || error.message || "Failed to update therapist";
      toast.error(msg);
      return rejectWithValue(msg);
    }
  }
);
